import { PageModel } from 'survey-core';

export const getStepName = (page: PageModel): string => {
  return page.name;
};
